import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Clock, Star } from 'lucide-react';

const HeroSection = ({ onBookNow }) => {
  return (
    <section id="home" className="relative min-h-screen pt-20 overflow-hidden bg-gradient-to-br from-slate-50 via-amber-50/30 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 right-0 w-96 h-96 bg-amber-200 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-100 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-medium">
              <Star className="w-4 h-4 fill-amber-500" />
              <span>Trusted by 10,000+ Travelers</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-800 leading-tight">
              Your Journey,
              <span className="block text-amber-600">Our Responsibility</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 max-w-lg leading-relaxed">
              Reliable vehicles for city rides, outstation trips, tours, and group travel across South India. Clean, comfortable, and dependable.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={onBookNow}
                className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-amber-500/25 hover:shadow-xl hover:shadow-amber-500/30 transition-all duration-300"
              >
                Book Your Ride
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button 
                variant="outline" 
                className="border-2 border-slate-200 hover:border-amber-500 hover:text-amber-600 px-8 py-6 text-lg rounded-xl transition-all duration-300"
              >
                View Fleet
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap items-center gap-6 pt-4">
              <div className="flex items-center gap-2 text-slate-600">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <Shield className="w-5 h-5 text-green-600" />
                </div>
                <span className="text-sm font-medium">Safe & Secure</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <Clock className="w-5 h-5 text-blue-600" />
                </div>
                <span className="text-sm font-medium">24/7 Support</span>
              </div>
              <div className="flex items-center gap-2 text-slate-600">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
                  <Star className="w-5 h-5 text-amber-600" />
                </div>
                <span className="text-sm font-medium">4.9 Rating</span>
              </div>
            </div>
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1612977063437-09444bd3e878?w=800&auto=format"
                alt="Travel on highways"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              
              {/* Floating Card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-slate-500">Starting from</p>
                    <p className="text-2xl font-bold text-slate-800">₹12<span className="text-base font-normal text-slate-500">/km</span></p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-slate-500">Vehicle Types</p>
                    <p className="text-lg font-semibold text-amber-600">Cars • SUVs • Buses</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-amber-400 rounded-2xl -z-10" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-amber-200 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
